// import React, { memo } from "react";

// import { Message, UserMentionDictionary } from "store/reducers/Chat/chat";
// import Text from "components/common/Text";
// import ChatMessage from "components/ChatMessage";

// import { mentioningConstants } from "../constants";

// interface ChatDayBlockProps {
//   day: string;
//   messages: Message[];
// }

// const parceMessageWithMentioning = (
//   message: string,
//   users?: UserMentionDictionary
// ) => {
//   if (
//     (!message.includes(mentioningConstants.startSymbol) &&
//       !message.includes(mentioningConstants.endSymbol)) ||
//     !users
//   )
//     return message;
//   return message
//     .split(mentioningConstants.splitStringRegExp)
//     .map((word) => {
//       const r = mentioningConstants.searchMentionUserInMessageRegExp.test(word);
//       if (r) {
//         const id = word.replace(mentioningConstants.searchSymbolsRegExp, "");
//         const user = users[id];
//         if (user) {
//           const replacedWord = word.replace(
//             mentioningConstants.searchMentionUserInMessageRegExp,
//             user.userName
//           );
//           return user
//             ? `<span class='message_user_mention'>${mentioningConstants.startSymbol}${replacedWord}</span>`
//             : word;
//         }
//       }
//       return word;
//     })
//     .join(" ");
// };

// const ChatDayBlock: React.FC<ChatDayBlockProps> = ({ day, messages }) => {
//   return (
//     <div className="chat_day_block">
//       <Text fontWeight="w500" className="chat_day_block_day">
//         {day}
//       </Text>
//       {messages.map((item) => {
//         const parseMessage = parceMessageWithMentioning(
//           item.message,
//           item.userMentions
//         );

//         return (
//           <ChatMessage
//             key={item.id}
//             isOwner={item.isOwner}
//             time={item.formattedTime}
//             senderName={item.senderName}
//             message={parseMessage}
//             type={item.type}
//             attachmentUrl={item.attachmentUrl}
//             thumbnailUrl={item.thumbnailUrl}
//           />
//         );
//       })}
//     </div>
//   );
// };

// export default memo(ChatDayBlock);

import React, { memo } from "react";

import {
  ChatBotMessageItem,
  Message,
  UserMentionDictionary,
  getIsFetchingSendMessageSelector,
} from "store/reducers/Chat/chat";
import Text from "components/common/Text";
import ChatMessage from "components/ChatMessage";
import ChatBotMessage from "components/ChatBotMessage/ChatBotMessage";
import { useAppSelector } from "hooks/redux";
import TypingIndicator from "components/TypingIndicator/TypingIndicator";

interface ChatDayBlockProps {
  day: string;
  messages: ChatBotMessageItem[];
}

const parceMessageWithMentioning = (
  message: string,
  users?: UserMentionDictionary
) => {
  let parcedMessage = message.replaceAll("\\n", `<br />`);

  if (users) {
    Object.entries(users).forEach(([id, user]) => {
      const regex = new RegExp(`@${id}#`, "g");
      const matches = message.match(regex);

      if (matches) {
        parcedMessage = parcedMessage.replaceAll(
          regex,
          `<span class='message_user_mention'>@${user.userName}</span>`
        );
      }
    });
  }
  // if (
  //   (!message.includes(mentioningConstants.startSymbol) &&
  //     !message.includes(mentioningConstants.endSymbol)) ||
  //   !users
  // )
  //   return message;
  // return message
  //   .split(mentioningConstants.splitStringRegExp)
  //   .map((word) => {
  //     const r = mentioningConstants.searchMentionUserInMessageRegExp.test(word);
  //     if (r) {
  //       const id = word.replace(mentioningConstants.searchSymbolsRegExp, "");
  //       const user = users[id];
  //       if (user) {
  //         const replacedWord = word.replace(
  //           mentioningConstants.searchMentionUserInMessageRegExp,
  //           user.userName
  //         );
  //         return user
  //           ? `<span class='message_user_mention'>${mentioningConstants.startSymbol}${replacedWord}</span>`
  //           : word;
  //       }
  //     }
  //     return word;
  //   })
  //   .join(" ");
  return parcedMessage;
};

const ChatDayBlock: React.FC<ChatDayBlockProps> = ({ day, messages }) => {
  const isLoading = useAppSelector(getIsFetchingSendMessageSelector);

  return (
    <div className="chat_day_block">
      <Text fontWeight="w500" className="chat_day_block_day">
        {day}
      </Text>
      {messages.map((item) => {
        const parseMessage = parceMessageWithMentioning(item.message);

        return (
          <ChatBotMessage
            key={item.id}
            isOwner={item.isOwner}
            time={item.formattedTime}
            senderName={item.senderName}
            message={parseMessage}
            type={item.type}
            videoUrl={item.videoUrl}
          />
        );
      })}
      {/* {isLoading && <TypingIndicator />} */}
    </div>
  );
};

export default memo(ChatDayBlock);
